import axios from 'axios';
import { v4 } from 'uuid';
import { useEffect, useState } from 'react';
import { history } from '../history';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { Link, Route, Router, Switch, useLocation, useParams } from 'react-router-dom';
import { ProgramConstant } from '../redux/reducers';
import { COUNTRIES, getRegion } from '../config/country';
import { API } from '../config/api';
import { COLORS } from '../config/color';
import RTTable from '../libs/table';
import { RTGroup } from '../libs/string';
import { RTCountrySelect } from '../libs/input';
import { idData, fetchData, insertData, updateData } from '../libs/db';
import { RTButton } from '../libs/button';
import PartnerTree from '../components/treepartners';
import { Store } from '../store'

const MemberCreate = ({ user, allgroups, mypartner, allpartner }) => {

	const dispatch = useDispatch();

	const [t] = useTranslation(['translation']);
	const { _id } = useParams("");
	const [ partner, setPartner ] = useState({});
	const [ data, setData ] = useState({});
	const [ process, setProcess ] = useState(false);
	const [ err, setErr ] = useState("");
    const domain = window.location.href.indexOf(".rayteams.com") > -1 ? "rayteams.com" : "raydevelop.com";

	useEffect(() => {
		init();
	},[mypartner, allpartner]);

	const init = async () => {
		dispatch({ type : ProgramConstant.PAGE, item : {
			label : t("Add a partner account"),
			caption : t("This account has administrative privileges and can login this partner portal")
		}});

		const qs = queryString.parse(window.location.search);
		if(qs?.partner){
			setPartner(allpartner.find(x => x._id === qs?.partner));
			return;
		}	
	}

	const createGroup = async () => {
		setProcess(true);
		
		const region = 'ap-northeast-2';
		const newUser = {
			name : data.username,
			email : data.useremail,
			password : data.userpassword,
			region,
			grouptype : "partner",
			groupId : user.partnerKey,
			partnerId : partner._id,
			partnerKey : user.partnerKey,
		}
		var retMember = await axios.post("https://api-ap-northeast-2-user." + domain + "/user",  {
			data : newUser } , {
				headers : { 
					'x-ray-device' : "RAYLINK" 
				} 
			}
		);

		if(retMember.data.status === "fail"){
			setProcess(false);
			setErr(retMember.data.error);
			return;
		}

		console.log(retMember.data.data);
		dispatch({ type : ProgramConstant.ADDUSER, user : retMember.data.data });

		setProcess(false);

		history.push("/partner?partner=" + partner._id);
	}
	
  	return <>
		{err && <div className="alert alert-warning shadow">{err}</div>}
		<div className="card mb-5 shadow">
			<div className="card-header">
				<div className="card-title">
					<span className="ms-2"> {t("Add an account - ")} '{partner.name}'</span>.
				</div>
				<div className="card-toolbar">
					<RTButton options={{
						label : "Cancel",
						color : COLORS.SECONDARY,
						action : () => history.push("/partner"),
					}} css="me-2" />
					<RTButton options={{
						label : process ? t('Please wait...') : (_id ? t("Update") : t("Create")),
						action : () => createGroup(),
						needValid : true
					}} valid={!!(data.username && data.useremail && data.userpassword)} />
				</div>
			</div>
			<form>
			<div className="card-body row">
                {/*
				<div className="mb-5 col-6">
					<label className="form-label fs-3">Choose Parent Partner</label>
					<div>
						<PartnerTree 
							selected={partner._id}
							onChanged={(e, id) => setParentPartner(allpartner.find(x => x._id === id))}/>
					</div>
				</div>
                */}
				<div className="col-12">
                    {/*
					<div className="mb-5">
						<label className="form-label fs-3">Partner Manager Account</label>
						<div className="alert alert-primary">
							{"This account has administrative privileges under the partner"} {data.name ? <span className="fw-bolder">({data.name})</span> : ""} {" being created."}
						</div>
					</div>
                    */}
					<div className="mb-5">
						<label className="form-label">Partner manager name</label>
						<input 
							type="text" 
							className="form-control form-control-solid" 
							placeholder="Manager Name" 
							value={data.username}
							onChange={(e) => setData({...data, username : e.target.value})}/>
					</div>
					<div className="mb-5">
						<label className="form-label">Partner manager email</label>
						<input 
							type="email" 
							className="form-control form-control-solid" 
							placeholder="Manager Email" 
							value={data.useremail}
							onChange={(e) => setData({...data, useremail : e.target.value})}/>
					</div>
					<div className="mb-5">
						<label className="form-label">Partner manager password</label>
						<input type="password" 
							className="form-control form-control-solid" 
							placeholder="Password" 
							value={data.userpassword || ""}
							onChange={(e) => setData({...data, userpassword : e.target.value})}/>
					</div>
					<div className="mb-5">
						<label className="form-label">Partner manager password confirm</label>
						<input type="password" 
							className="form-control form-control-solid" 
							placeholder="Password" 
							value={data.userpassword2 || ""}
							onChange={(e) => setData({...data, userpassword2 : e.target.value})}/>
					</div>
				</div>
				<div>
				</div>
			</div>
			</form>
		</div>
		
	</>
}

const mapState = (state) => {
	const user =  state.AuthReducer.user;
	const allgroups =  state.ProgramReducer.allgroups;
	const allpartner =  state.ProgramReducer.allpartner;
	const mypartner =  state.ProgramReducer.mypartner;

	return { user, allgroups, mypartner, allpartner };
};

const mapDispatch = (dispatch) => ({
	
});

export default connect(mapState, mapDispatch)(MemberCreate);
